import { Logos3 } from "@/components/blocks/logos3";

const demoData = {
  heading: "Udvalgte samarbejder",
  logos: [
    {
      id: "jobindex",
      description: "Jobindex",
      image: "/partners/jobindex.png",
      className: "h-20 w-auto object-contain",
    },
    {
      id: "localaway",
      description: "LocalAway",
      image: "/partners/localaway.png",
      className: "h-20 w-auto object-contain",
    },
    {
      id: "hojskolendk",
      description: "HÖJSKOLENDK",
      image: "/partners/hojskolendk.png",
      className: "h-20 w-auto object-contain",
    },
  ],
};

function Logos3Demo() {
  return <Logos3 {...demoData} />;
}

export { Logos3Demo };
